module.exports = __webpack_public_path__ + "static/img/4317_phase_function_Paper_PointsHejduk_Prediction.ed42682.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4317_phase_function_Paper_PointsHejduk_Prediction.png
// module id = H9pg
// module chunks = 0